(function ($) {

    var MENU_TRIGGER = ".nav-icon-trigger";
    var SEARCH_TRIGGER = ".nav-main-search-trigger";
    var DROPDOWN_MENU = ".dropdown-menu";
    var MOBILE_MENU_TITLE = ".menu-nav-indicator";
    var MAIN_NAV = ".nav-main-bar";

    //function addmenutitle(navBarScope) {
    //    if ($(".nav-main-bar .menu-nav-indicator-container").length) {
    //        $(".nav-main-bar .menu-nav-indicator-container").empty().remove();
    //    }
    //    //if ($(window).width() < 991) {
    //    //    var menuTitle = $(navBarScope).find('span').html();
    //    //   $(MAIN_NAV).append('<div class="menu-nav-indicator-container"><div class="menu-nav-indicator"><p>' + menuTitle + '</p></div></div>');
    //    //    $("menu-nav-indicator-container").parent().on("click", slideOutAnimation);
    //    //}
    //    $(".search-box").addClass("hide");
    //    //$(".nav-main-item").removeClass("nav-main-item-active");
    //    $(".nav-main-search-trigger").addClass("transparent");
    //}

    function slideOutAnimation() {
        if ($(window).width() < 991) {
            
            $(DROPDOWN_MENU).filter(".lang-dropdown.hide").css({ "display": 'none' });
            $(".nav-item>.dropdown-menu.show").removeClass("show");
            if ($(".nav-main-bar .menu-nav-indicator").length) {
                $(".nav-main-bar .menu-nav-indicator").remove();
            }
        }
    }

    function stopSlideOut() {
        $(DROPDOWN_MENU).removeClass("hide").removeAttr('style');
        if ($(".nav-main-bar .menu-nav-indicator").length) {
            $(".nav-main-bar .menu-nav-indicator").remove();
        }

    }

    function scrolltoTop() {
        if ($('.dropdown-menu').hasClass('show')) {
            $(window).scrollTop(0);
        }
    }

    $(window).resize(function () {

        $(".dropdown-menu .nav-chat").each(function (item) {
            if ($(this).hasClass('w-100')) {
                var screenWidth = $(window).width();
                if (screenWidth > 560 && screenWidth < 991) {
                    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                        var height = ($(this).attr("data-brand-image-height") != undefined && $(this).attr("data-brand-image-height") != '') ? $(this).attr("data-brand-image-height") : "55px";
                        var width = ($(this).attr("data-brand-image-width") != undefined && $(this).attr("data-brand-image-width") != '') ? $(this).attr("data-brand-image-width") : "300px";
                        $(this).find('.navbrand').attr('height', height);
                        $(this).find('.navbrand').attr('width', width);
                        $(this).find('.chat-wrapper').attr('style', 'margin-top: 5.7% !important');
                    }
                    else if (/android/i.test(navigator.userAgent)) {
                        $(this).find('.chat-wrapper').attr('style', 'margin-top: 9% !important');
                    }

                }
                else {
                    $(this).find('.navbrand').removeAttr('height');
                    $(this).find('.navbrand').removeAttr('width');
                    $(this).find('.chat-wrapper').removeAttr('style', 'margin-top: 3% !important');
                }
            }
        });
        if ($(window).width() < 991) {
            $(DROPDOWN_MENU).removeClass("hide").removeAttr('style');
        }
        displayChatWrapper();
    });





    // for FLWEP2-7881 - accordian menu
    $(document).ready(function () {
        if ($(window).width() < 992) {



            $("li.nav-meganav-subitem").each(function () {
                if (!$(this).hasClass(".nav-expandable-menu")) {
                    var clss = $(this).find(".dropdown-menu").length;
                    if (clss > 0) {
                        $(this).find(".nav-link-icon").closest(".dropdown-item").css("margin-bottom", "-10px");
                        $(this).css("padding-bottom", "0px");
                    } else {
                        $(this).find(".nav-link-icon").closest(".dropdown-item").css("margin-bottom", "8px");
                    }
                } else {
                    $(this).find(".nav-link-icon").closest(".dropdown-item").css("margin-bottom", "-20px");
                }

            });
        }
    });






    $(MENU_TRIGGER).on("click ", stopSlideOut);
    $(".nav-link").on("click ", function () {
        //addmenutitle(this);
        if (!($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
            scrolltoTop();
        }
        if ($('.nav-main-search-trigger.nav-main-item-active').length) {
            $('.nav-main-search-trigger').click();
        }
    });
    $(".nav-top-bar .nav-chat .nav-chat-trigger").on("click", function (e) {
        displayChatWrapper(e);
    });
    $(".nav-main-item,.nav-link").on("click", function (e) {
        if ($(".nav-chat-on").length) {
            $(".nav-chat-on .close-button").click();
        }
    });
    $(".nav-item").on("click", function (e) {
        if (!$(e.currentTarget).hasClass("show") && $(".nav-chat-on").length) {
            $(".nav-chat-on .close-button").click();
        }
    });
    $(".nav-meganav-col.nav-chat").on("click", function (e) {
        displayChatWrapperMenu(e);
    });
    $(".nav-meganav-subitem .nav-chat").on("click", function (e) {
        $(this).toggleClass("nav-chat-on");
        // FLWEP2-4565 - GA event changes
        var eventObj;
        if ($(e.currentTarget).hasClass("nav-chat-on")) {
            $(analytics.eventConfig).each(function (index, component) {

                if (component.target === ".nav-header.icon-nav-header .nav-main-bar") {
                    $(component.events).each(function (index2, event) {
                        if (event.eventTarget === ".dropdown-menu.show .contains-nav-chat .nav-chat a.nav-chat-trigger") {
                            eventObj = analytics.eventConfig[index].events[index2];
                        }
                    });

                }
            });
            var tags = parseDynamicValues($(this), eventObj);
            var index = tags.elementText.indexOf('\n');
            var elementText = tags.elementText.split('\n');
            tags.elementText = elementText[0];
            if ($(this).attr("isSubmittedFlag") == "true" && eventObj.eventType === "submit") {
                $(this).attr("isSubmittedFlag", false);
                blockEventCapture(tags);
            } else if (eventObj.eventType !== "submit") {
                blockEventCapture(tags);
            }
        }
        e.stopPropagation();
        displayChatWrapperMenu(e);
    });
    $(".nav-meganav-title .nav-chat").on("click", function (e) {
        $(this).toggleClass("nav-chat-on");
        e.stopPropagation();
        displayChatWrapperMenu(e);
    });
    if ($(".nav-main-mobile-panel").length) {
        $(".nav-main-mobile-panel .contains-nav-chat .nav-chat").on("click", function (e) {
            $(this).toggleClass("nav-chat-on");
            e.stopPropagation();
            displayChatWrapperMenuMobile(e);
        });
    }

    function displayChatWrapperMenuMobile(e) {
        $(".nav-chat .chat-wrapper").css({ "transform": "scale(0)" });
        setTimeout(function () {
            var hasClass = $(e.currentTarget).hasClass("nav-chat-on");
            $(".nav-chat-on").removeClass("nav-chat-on");
            if (hasClass) {
                $(e.currentTarget).addClass("nav-chat-on");
            }

            if ($(".nav-chat-on").length) {
                if (($(".nav-chat-on .chat-wrapper").parents(".nav-main-mobile-panel")[0].offsetLeft + 80 + $(".nav-chat-on .chat-wrapper")[0].clientWidth) < window.outerWidth) {
                    $(".icon-nav-header .nav-chat-on").removeClass("overflowsRight");
                    $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1)" });

                } else {
                    $(".icon-nav-header .nav-chat-on").addClass("overflowsRight");
                    $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1) translateX(-" + (($(".nav-chat-on .chat-wrapper").parents(".nav-main-mobile-panel")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth + 105) - window.outerWidth) + "px) translateY(0px)" });
                }
            }
        }, 241);
    }
    function displayChatWrapperMenu(e) {
        $(".nav-chat .chat-wrapper").css({ "transform": "scale(0)" });
        setTimeout(function () {
            var hasClass;
            if (e) {
                hasClass = $(e.currentTarget).hasClass("nav-chat-on");
            }
            $(".nav-chat-on").removeClass("nav-chat-on");
            if (hasClass) {
                $(e.currentTarget).addClass("nav-chat-on");
                if ($(window).width() < 991) {
                    $(e.currentTarget).closest(".dropdown").css('z-index', '1005');
                }
            } else {
                if ($(window).width() < 991) {
                    $(e.currentTarget).closest(".dropdown").css('z-index', '');
                }
            }
            if ($(".nav-chat-on").length) {
                var overflow_qr = (($(".nav-chat-on .chat-wrapper").parents(".nav-meganav-col")[0].offsetLeft + 80 + $(".nav-chat-on .chat-wrapper")[0].clientWidth) < window.outerWidth);
                var mobileDevice = ((window.innerWidth > 321) && (window.innerWidth <= 426));
                var leftNavItem = ($(".nav-chat-on .chat-wrapper").parents(".left-nav-item").length > 0);
                if (($(".nav-chat-on .chat-wrapper").parents(".nav-meganav-col")[0].offsetLeft + 80 + $(".nav-chat-on .chat-wrapper")[0].clientWidth) < window.outerWidth) {
                    $(".icon-nav-header .nav-chat-on").removeClass("overflowsRight");
                    $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1)" });

                }
                else if ($(".nav-chat-on .chat-wrapper").parents(".left-nav-item").length > 0) {
                    if (($(".nav-chat-on .chat-wrapper").parents(".left-nav-item")[0].offsetLeft + 80 + $(".nav-chat-on .chat-wrapper")[0].clientWidth) < window.outerWidth) {
                        $(".icon-nav-header .nav-chat-on").removeClass("overflowsRight");
                        $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1)" });
                    }
                }
                else if ((overflow_qr == false) && (leftNavItem == false) && (mobileDevice == true)) {
                    setTimeout(function () {
                        $(".nav-chat-on .chat-wrapper .qrcode .qr-row").css({ "display": "block" });
                        $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1)" });
                    }, 500);
                }
                else {
                    $(".icon-nav-header .nav-chat-on").addClass("overflowsRight");
                    $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1) translateX(-" + (($(".nav-chat-on .chat-wrapper").parents(".nav-meganav-col")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth + 105) - window.outerWidth) + "px) translateY(0px)" });
                }
            }
        }, 241);
    }
    function displayChatWrapper(e) {
        $(".nav-chat .chat-wrapper").css({ "transform": "scale(0)" });
        setTimeout(function () {
            var hasClass;
            if (e) {
               hasClass = $(e.currentTarget).parents(".nav-chat").hasClass("nav-chat-on");
            }
            $(".nav-chat-on").removeClass("nav-chat-on");
            if (hasClass) {
                $(e.currentTarget).parents(".nav-chat").addClass("nav-chat-on");
            }
            if ($(".nav-chat-on").length) {
                var overflow_qr_social = (($(".nav-chat-on .chat-wrapper").parent(".nav-chat-on")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth) < window.outerWidth);
                var mobileDeviceSocial = ((window.innerWidth > 321) && (window.innerWidth <= 426));
                if (($(".nav-chat-on .chat-wrapper").parent(".nav-chat-on")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth) < window.outerWidth) {
                    $(".icon-nav-header .nav-chat-on").removeClass("overflowsRight");
                    $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1)" });

                }
                else if ((overflow_qr_social == false) && (mobileDeviceSocial == true) && (($("header").hasClass("icon-nav-header")) == true)) {
                    setTimeout(function () {
                        $(".nav-chat-on .chat-wrapper .qrcode .qr-row").css({ "display": "block" });
                        $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1) translateX(-" + (($(".nav-chat-on .chat-wrapper").parent(".nav-chat-on")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth + 25) - window.outerWidth) + "px) translateY(0px)" });
                    }, 500);
                }
                else if ((overflow_qr_social == false) && (mobileDeviceSocial == true) && (($("header").hasClass("icon-nav-header")) == false)) {
                    setTimeout(function () {
                        $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1) translateX(-" + (($(".nav-chat-on .chat-wrapper").parent(".nav-chat-on")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth + 25) - window.outerWidth) + "px) translateY(0px)" });
                        $(".nav-chat-on .chat-wrapper .qrcode .qr-row").css({ "display": "block" });
                    }, 500);
                }
                else {
                    $(".icon-nav-header .nav-chat-on").addClass("overflowsRight");
                    $(".nav-chat-on .chat-wrapper").css({ "transform": "scale(1) translateX(-" + (($(".nav-chat-on .chat-wrapper").parent(".nav-chat-on")[0].offsetLeft + $(".nav-chat-on .chat-wrapper")[0].clientWidth + 25) - window.outerWidth) + "px) translateY(0px)" });
                }
            }
        }, 241);
    }
    //closes menu when search open
    $(SEARCH_TRIGGER).on("click ", function () {
        if ($(".navbar-collapse").hasClass("show")) {
            $('.collapse').collapse('hide');
            $(".search-box").removeClass("hide");
        }
        if ($(MENU_TRIGGER).hasClass("nav-main-item-active")) {
            $(MENU_TRIGGER).removeClass("nav-main-item-active");
        }
        if ($(".nav-main-bar .menu-nav-indicator").length) {
            $(".nav-main-bar .menu-nav-indicator").remove();
        }
        $(".search-box").removeClass("hide");
        $(".nav-main-search-trigger").removeClass("transparent");
    });

    $(".dropdown-item").each(function (item) {
        var hasIcon = $(this).find(".nav-link-icon");
        var hasQR = $(this).next(".nav_qr");
        if (hasIcon.length) {
            $(this).next('.dropdown-menu.show').addClass('hasIconPadding');
        } else {
            $(this).next('.dropdown-menu.show').addClass('noIconPadding');
        }
        if (hasQR.length) {
            $(this).next(".nav_qr").next('.dropdown-menu.show').addClass('hasIconPadding');
        } else {
            $(this).next(".nav_qr").next('.dropdown-menu.show').addClass('noIconPadding');
        }
    });
    $(".dropdown-menu .nav-chat").each(function (item) {

        if ($(this).hasClass('w-100')) {
            var screenWidth = $(window).width();
            // changing it from 960 to 991
            if (screenWidth > 560 && screenWidth < 991) {
                if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                    var height = ($(this).attr("data-brand-image-height") != undefined && $(this).attr("data-brand-image-height") != '') ? $(this).attr("data-brand-image-height") : "55px";
                    var width = ($(this).attr("data-brand-image-width") != undefined && $(this).attr("data-brand-image-width") != '') ? $(this).attr("data-brand-image-width") : "300px";
                    $(this).find('.navbrand').attr('height', height);
                    $(this).find('.navbrand').attr('width', width);
                    $(this).find('.chat-wrapper').attr('style', 'margin-top: 5.7% !important');
                }
                else if (/android/i.test(navigator.userAgent)) {
                    $(this).find('.chat-wrapper').attr('style', 'margin-top: 9% !important');
                }

            }
            else {
                $(this).find('.navbrand').removeAttr('height');
                $(this).find('.navbrand').removeAttr('width');
                $(this).find('.chat-wrapper').removeAttr('style');
            }
        }

        var hasIcon = $(this).siblings(".nav-link-icon");
        if (hasIcon.length) {
            $(this).next('.dropdown-menu.show').addClass('hasIconPadding');
        } else {
            $(this).next('.dropdown-menu.show').addClass('noIconPadding');
        }
    });


    // for adding posiion top to the nav-main-icons class- 7722
    $(".nav-icon-trigger").on("click", function () {
        if (($('.nav-icon-trigger').attr("aria-expanded") === "true")) {
            $('.nav-icon-trigger').next(".nav-main-icons").css("top", "5.3rem");
           $('.icon-nav-header .nav-main-bar').css("min-height", "85px");
        }
        else if ($('.nav-icon-trigger').attr("aria-expanded") === "false") {
            $('.nav-icon-trigger').next(".nav-main-icons").css("top", "4.5rem");
            $('.icon-nav-header .nav-main-bar').css("min-height", "70px");
        }
    });

    // for changing nav-bar height on click of search icon 7722
    $(".nav-main-search-trigger").on("click", function () {
        if ($(".nav-main-item-active").length) {
            $('.icon-nav-header .nav-main-bar').css("min-height", "70px");
        } else {
            $('.icon-nav-header .nav-main-bar').css("min-height", "85px");
        }
    });


}(window.jQuery));
/*FLWEP2-7816- hide harburger for mobil for business site*/

(function ($) {
    function hideHamburgerIcon() {
        var width = $(window).width();
        if ($(".nav-header").hasClass("icon-nav-header")) {
            if ($(".nav-main-bar").find("nav").length == 0 && !$(".nav-main-bar").parents("body").hasClass("on-page-editor")) {
                $(".nav-main-bar").css('display', 'none');
            }
        }
        if (width >= 768) {
            if (($('.nav-wrapper').parents().hasClass('nav-main-left')) == true) {
                $(".nav-wrapper").css('min-height', 'unset');
            }
            else {
                $(".nav-wrapper").css('min-height', '69px');
            }
        }
        
        else {
            if ($(".nav-header").hasClass("icon-nav-header")) {
                if ($(".icon-nav-header").find(".enlarge-logo").length > 0) {
                    $(".nav-wrapper").css('min-height', '115px');
                }
                else {
                    $(".nav-wrapper").css('min-height', '58px');
                }
            }
        }
    }

    $(document).ready(function () {
        hideHamburgerIcon();
    });
    $(window).resize(function () {
        hideHamburgerIcon();
    });
}(window.jQuery));


// for FLWEP2-7902/8269 - extra whit space in korean site
(function ($) {
    function breadcrumbSpace() {
        if ($(window).width() < 992) {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                if ($(".headerkorea").hasClass("fixed-nav-header")) {
                    $(".headerkorea .breadcrumb-panel").removeClass("breadcrumbPos-IOS");
                } else {
                    $(".headerkorea .breadcrumb-panel").addClass("breadcrumbPos-IOS");
                }
            }
            else if (/android/i.test(navigator.userAgent)) {
                $(".headerkorea .breadcrumb-panel").removeClass("breadcrumbPos-IOS");
            }
        } else {
            $(".headerkorea .breadcrumb-panel").removeClass("breadcrumbPos-IOS");
        }
    }
    $(document).ready(function () {
        breadcrumbSpace();
    });
    $(window).resize(function () {
        breadcrumbSpace();
    });


}(window.jQuery));


(function ($) {
    $(document).ready(function () {
        mainNavInit();
    });
    $(window).resize(function () {
        mainNavInit();
    });

    function mainNavInit() {
        var $mainNavLinks = $(".nav-item.dropdown");
        if (!$mainNavLinks.length) return;
        var currentURL = location.href.replace(location.search, "").split("#")[0];
        var shortURL = currentURL.split("/");
        shortURL = shortURL.filter(Boolean);
        var shortURL_active = "/" + shortURL[shortURL.length - 1];
        if (window.location.hash !== "") {
            shortURL_active = shortURL_active + window.location.hash;
        }
        function compareSpacesToDashes(link1, link2) {
            if (link2.indexOf("-") > 0) {
                link1 = link1.replace(/%20/g, "-");
                link2 = link2.replace(/%20/g, "-");
            }
            return link1 === link2;
        }
        $mainNavLinks.each(function () {
            var targetEl = $(this).children(".nav-link.dropdown-toggle").first();
            if (!targetEl.attr("href").includes("void")) {
                linkURL = targetEl.attr("href");
                if (linkURL.substr(-1) === "/") {
                    linkURL = linkURL.substr(0, linkURL.length - 1);
                }
                if (linkURL !== undefined) {
                    shortLinkURL = linkURL.split("/");
                    finalLinkURL = "/" + shortLinkURL[shortLinkURL.length - 1];
                    if (linkURL) {
                        linkURL =
                            linkURL[linkURL.length - 1] === "/" ? linkURL.substring(0, linkURL[linkURL.length - 2]) : linkURL;
                        if (linkURL.indexOf("http") > -1) {
                            if (compareSpacesToDashes(currentURL, encodeURI(linkURL))) {
                                $(this).addClass("link_active");
                                targetEl.attr("aria-current", "page");
                            }
                        } else if (
                            compareSpacesToDashes(shortURL_active, encodeURI(linkURL))
                        ) {
                            $(this).addClass("link_active");
                            targetEl.attr("aria-current", "page");
                        } else if (
                            compareSpacesToDashes(shortURL_active, encodeURI(finalLinkURL))
                        ) {
                            $(this).addClass("link_active");
                            targetEl.attr("aria-current", "page");
                        }
                    }
                }
            }
        });
    }
})(window.jQuery);

//Analytics for QRCodes.cshtml
analytics.eventConfig.push({
    "target": ".component.qrcode",
    "codeId": "qr",
    "events": [
        {
            "eventTarget": ".qr-button",
            "eventType": "click",
            "tags": {
                "componentId": "qr",
                "componentName": "qr component",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "save button",
                "event": "navigation",
                "eventType": "save qr code click"
            }
        }
    ]
});